module.exports = __webpack_public_path__ + "static/img/icon.fd11126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tianlian/icon.png
// module id = 5H+/
// module chunks = 5